import React from 'react';
import * as PropTypes from 'prop-types';
import { Table, TableBody, TableCell, TableHead, TableRow, } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

IncrementTableContent.propTypes = {
  incrementData: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    minAmount: PropTypes.number.isRequired,
    uptoAmount: PropTypes.number.isRequired
  }).isRequired
  ).isRequired,
  currencySymbol: PropTypes.string.isRequired
};

const useStyles = makeStyles(theme => ({
  container: {
    textAlign: 'center',
    margin: 'auto'
  }
}));

function IncrementTableContent({ incrementData, currencySymbol }) {
  const classes = useStyles();

  const getFromValue = (lastMinAmount) => {
    lastMinAmount = Number((lastMinAmount == null ? 0.00 : lastMinAmount.minAmount.toFixed(2)));
    return (lastMinAmount + 0.01).toFixed(2);
  };

  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>Range ({currencySymbol})</TableCell>
          <TableCell>Bid Increment ({currencySymbol})</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {incrementData.map((cell, i) => (
          <TableRow key={i}>
            <TableCell>{getFromValue(incrementData[i - 1])}-{cell.minAmount}</TableCell>
            <TableCell>{cell.uptoAmount}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}

export default IncrementTableContent;